export default {
  scrollLeft: {
    id: 'product_list_facet_filters_scroll_left',
    defaultMessage: 'Scroll filters left',
  },
  scrollRight: {
    id: 'product_list_facet_filters_scroll_right',
    defaultMessage: 'Scroll filters right',
  },
}
